import * as d3 from 'd3';
const generateBarbellGraphic = (weight, barWeight, weights, isMetric) => {
    function howToRack(weight, barWeight, weights) {
      if (weight % 5 !== 0) {
          weight = parseFloat(weight) +  parseFloat ((5 - (weight % 5)));
        }
        var toRack = [];
        var left = weight - barWeight;
        var localWeights = new Map(Object.entries(weights).map(([key, value]) => [parseFloat(key), value]));
        while (left > 0) {
          var found = false;
          
          // find largest possible weight to add
          var maxWeight = 0;
          for (let [weight, numPlates] of localWeights) {
            var amt = weight * 2;
            if (numPlates > 0 && amt <= left && weight >= maxWeight) {
              maxWeight = weight;
              found = true;
            }
          }
          
          if (!found) {
            toRack = [];
            break;
          }
          
          left -= maxWeight * 2;
          localWeights.set(maxWeight, localWeights.get(maxWeight) - 2);
          toRack.push(maxWeight);
        }
        
        return toRack;
      }
    
    function barbellSVG(isMetric=false, weight, weights, barweight) {
        var res = howToRack(
            weight,
            barWeight,
            weights)
        // fallback to brute force if greedy fails
    
        var justBar = false;
    
        if (Number(weight) === Number(barWeight)) {
            justBar = true;
        }

        var svg = d3.create("svg")
        .append("svg")
            .attr("id", "svgresult")
            .attr("width", 200)
            .attr("height", 550);
    
            
    
        if (!justBar && res.length === 0) {
            /* Not Rackable */
            svg.append("text")
                .attr("x", 10)
                .attr("y", 200)
                .text("Not Rackable!");
    
        } else {
            console.log(res);
            var plateSum = 2 * res.reduce((a, b) => { return Number(a) + Number(b); }, 0)
            console.log(plateSum + barWeight);
    
            var barTop = 0;
            var barBottom = 550;
            var barWidth = 10;
            var barHorizCenter = 100 + barWidth / 2;
    
            svg.append("rect")
                .attr("id", "thebar")
                .attr("width", barWidth)
                .attr("height", barBottom - barTop)
                .attr("x", barHorizCenter - barWidth / 2)
                .attr("y", barTop);
    
            var scaleWidth = d3.scaleLinear().domain([1.25, 100]).range([50, 300]);
            var plateHeight = 20;
    
            var colors = {
                2.5: "#777",
                5: "#777",
                10: "#0074D9",
                25: "#2ECC40",
                35: "#FF851B",
                45: "#FF4136"
              };

              var metricColors = {
                1.25: "#777",
                2.5: "#777",
                5: "#0074D9",
                10: "#2ECC40",
                15: "#FF851B",
                20: "#FF4136",
              };
              
              function weightColorClass(weight, isMetric) {
                 // Get the color from the array based on the weight
                 var color;
                 if (isMetric) {
                     color = metricColors[weight];
                 } else {
                 color = colors[weight];
                 }
                 return color ? color : "white";
              };
              
              
              function drawPlate(svg, y, weight, isMetric) {
                var plateWidth = scaleWidth(weight);
                svg.append("rect")
                  .attr("fill", weightColorClass(weight, isMetric))
                  .attr("width", plateWidth)
                  .attr("height", plateHeight)
                  .attr("x", barHorizCenter - (plateWidth / 2))
                  .attr("y", y);
              }
              
              function drawPlateLabel(svg, x, y, label, isMetric) {
                svg.append("text")
                  .attr("class", "plateLabel")
                  .attr("fill", "white")
                  .attr("x", x)
                  .attr("y", y)
                  .text(label);
              }
              
              var numPlates = res.length;
              res.reverse(); // reverse the array
              for (var plate = 0; plate < numPlates; plate++) {
                var weight = res[plate];
                drawPlate(svg, 5 + barTop + plate * 25, weight, isMetric);
                drawPlateLabel(svg, barHorizCenter, 5 + barTop + plate * 25 + plateHeight - 2, weight, isMetric);
              
                drawPlate(svg, barBottom - (1 + plate) * 25, weight, isMetric);
                drawPlateLabel(svg, barHorizCenter, barBottom - (1 + plate) * 25 + plateHeight - 2, weight, isMetric);
              }
              console.log(svg);

        return svg.node().outerHTML;;
    }
}

return barbellSVG(isMetric, weight, weights, barWeight)      
    
};
export default generateBarbellGraphic;